// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1kjJV","file":"styles_file__3vFxk"};